module.exports = __webpack_public_path__ + "img/10dda6f.png";